import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box, LinkText } from '@components/common';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import { SERVICE_TYPES, FREQUENCIES, BOOKING_STAGE } from '@services/minte';

const Wrapper = styled(Box)`
  position: absolute;
  display: flex;
  flex-direction: ${props => (props.topbarMode ? 'row' : 'column')};

  @media screen and (min-width: 768px) and (max-width: 1023px) {
    ${props =>
      props.topbarMode
        ? {
            width: '100%',
            height: '60px',
            top: '24px',
            justifyContent: 'center',
            alignItems: 'center'
          }
        : {
            maxWidth: '270px',
            width: '270px',
            left: '27px',
            top: '220px'
          }}
  }
  @media screen and (min-width: 1024px) {
    ${props =>
      props.topbarMode
        ? {
            width: '100%',
            height: '60px',
            top: '24px',
            justifyContent: 'center',
            alignItems: 'center'
          }
        : {
            maxWidth: '270px',
            width: '270px',
            left: '90px',
            top: '220px'
          }}
  }

  @media screen and (max-width: 767px) {
    display: none;
  }

  ${props =>
    props.isHidden && {
      display: 'none'
    }}
`;

function BookingNavbar(props) {
  const {
    selectedFrequency,
    selectedServiceType,
    bookingStep,
    goToStep,
    isPMUser
  } = props;
  const isTopBarMode = selectedFrequency === FREQUENCIES.REGULARLY;

  const isMoveOutMode = selectedServiceType === SERVICE_TYPES.MOVE_OUT;

  let navItems = [
    {
      step: BOOKING_STAGE.FREQUENCY,
      title: 'Service Frequency'
    },
    {
      step: BOOKING_STAGE.SERVICE_TYPE,
      title: isTopBarMode ? 'Schedule' : 'Service Types'
    },
    {
      step: BOOKING_STAGE.ADDON,
      title: 'Additional Services'
    },
    {
      step: BOOKING_STAGE.SERVICE_DATE,
      title: isTopBarMode ? 'Start Date' : 'Service Date'
    },
    {
      step: BOOKING_STAGE.CONFIRM,
      title: 'Confirm'
    }
  ];

  if (isPMUser) {
    navItems = [
      {
        step: BOOKING_STAGE.RECIPIENT,
        title: 'Service Recipient'
      },
      ...navItems
    ];
  }

  if (isMoveOutMode) {
    navItems = [
      {
        step: BOOKING_STAGE.SERVICE_DATE,
        title: isTopBarMode ? 'Start Date' : 'Service Date'
      },
      {
        step: BOOKING_STAGE.CONFIRM,
        title: 'Confirm'
      }
    ];
  }

  const itemLayoutProps = isTopBarMode
    ? {
        mr: 5,
        ml: 0
      }
    : {
        mb: 5,
        mt: 0
      };

  const indexMap = Object.values(BOOKING_STAGE).reduce(
    (acc, current, index) => {
      acc[current] = index;
      return acc;
    },
    {}
  );

  const isActiveTab = itemStep => {
    if (bookingStep === itemStep) {
      return true;
    }

    if (
      bookingStep === BOOKING_STAGE.TIMEFRAME &&
      itemStep === BOOKING_STAGE.SERVICE_DATE
    ) {
      return true;
    }
  };

  return (
    <Wrapper topbarMode={isTopBarMode}>
      {navItems.map(item => {
        const isDisabled = indexMap[bookingStep] < indexMap[item.step];

        return (
          <LinkText
            key={item.step}
            activeTab={isActiveTab(item.step)}
            disabled={isDisabled}
            onClick={() => {
              goToStep(item.step);
            }}
            {...itemLayoutProps}
          >
            {item.title}
          </LinkText>
        );
      })}
    </Wrapper>
  );
}

BookingNavbar.propTypes = {
  selectedFrequency: PropTypes.string,
  selectedServiceType: PropTypes.string,
  bookingStep: PropTypes.string.isRequired,
  goToStep: PropTypes.func.isRequired,
  isPMUser: PropTypes.bool
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state),
  selectedServiceType: BookingSelectors.selectServiceType(state),
  bookingStep: BookingSelectors.selectCurrentStep(state),
  isPMUser: AuthSelectors.selectIsPMUser(state)
});

const mapDispatchToProps = dispatch => ({
  goToStep: step => dispatch(BookingActions.setBookingStep(step))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(BookingNavbar);
